import * as modal from "../../util/modal.ts";
import * as forms from "../../util/forms.js";
import * as amplify from "../../util/amplify.ts";
import * as Locale from "../../util/Locale.js";
import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import * as DateUtils from "../../lib/DateUtils.ts";
import {openLimitModal,openCategoryLimitModal} from "../../ui/modal/budgetModal.js";
import ApiServer from "../../ApiServer.js";
import * as Confetti from "../../lib/Confetti.js";
import * as FwDatas from "../../FwDatas.ts";
import {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary} from "../../server/objects/BudgetBeans.js";


const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

var souscription = undefined
function destroy(form){
  amplify.unsubscribe('budgetmodified',souscription)
}
function init(form){
  var 
    metaId = form.metaId(),
    budgetBean = metaId?budgetCache.get(metaId).cloneWith({}):new ApiServer.types.BudgetBean({
      name:"",
      budgetLimit:"1000",
      budgetLimitActive:"false",
      currencyCode:Locale.guessCurrency(),
      recurrency:"MONTHLY",
      recurrencyStartDay:1,
      budgetCategoryLimits:{},
      sharedToAll:"true",
      paidUsage:"NONE",
      sharedMemberIds:[],
      accountId:FwDatas.getAccountId(),
      rights:{}
      }),
    name = form.find('input[name=name]'),
    emoji = form.find('input[name=emoji]'),
    isrecurrent = form.find('select[name=isrecurrent]'),
    recurrency = form.find('select[name=recurrency]'),
    recurrencyStartDay = form.find('select[name=recurrencyStartDay]'),
    budgetLimit = form.find('input[name=budgetLimit]'),
    budgetCategoryLimits = form.find('input[name=budgetCategoryLimits]'),
    currencyCode = form.find('select[name=currencyCode]'),
    paidUsage = form.find('select[name=paidUsage]'),
    markallaspaid = form.find(".markallaspaid"),
    
    submit = form.find('*[type=submit]');
  
  amplify.subscribe('budgetmodified',updateUI)
  souscription = updateUI
  function updateUI(recurrencyChanged){
    name.val(budgetBean.name);
    submit.toggleClass("secondary",name.val().trim().length===0)
    
    if(budgetBean.budgetLimitActive){
      budgetLimit.val(budgetBean.formatAmount(budgetBean.budgetLimit))  
    }else{
      budgetLimit.val('')  
    }
    
    isrecurrent.val(""+(budgetBean.recurrencyDescriptor.recurrency!=='NONE'))
    
    var 
      isRecurrent = budgetBean.recurrencyDescriptor.recurrency!=='NONE';
    
    recurrency.parent('label').toggle(isRecurrent)
    recurrency.val(budgetBean.recurrencyDescriptor.recurrency) 
    
      switch(budgetBean.recurrencyDescriptor.recurrency){
        case 'YEARLY':{
          recurrencyStartDay.parent('label').show()
          var 
            optGroups = [],
            optionsHtml;
          DateUtils.getYearRange(new Date('2010-01-02')).getDays().forEach(day=>{
            var group = optGroups[day.date.getMonth()];
            if(group===undefined){
              group = optGroups[day.date.getMonth()] = {name:day.date.toLocaleString(i18n.getSelectedLanguage(), {month:"long"}),days:[]}
            }
            group.days.push(day)
          })
          var recurrencyStartDayInput = 1;
          optionsHtml = optGroups.map(group=>{
            var options = group.days.map((day)=>'<option '+(recurrencyStartDayInput===1?'selected':'')+' value="'+(recurrencyStartDayInput++)+'">'+day.date.toLocaleString(i18n.getSelectedLanguage(), { day:"numeric", month:"long"})+'</option>').join('')
            return '<optgroup label="'+group.name.toUpperCase()+'">'+options+'</optgroup>'; 
          }).join('')
          recurrencyStartDay.html(optionsHtml)
          recurrencyStartDay.val(budgetBean.recurrencyStartDay).trigger('change')
          break;
        }
        case 'MONTHLY':{
          recurrencyStartDay.parent('label').show()
          recurrencyStartDay.html(
            '<option value="1">'+i18n.get("recurrency.firstofmonth")+'</option>'+
            [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30].map(idx=>'<option value="'+idx+'">'+idx+'</option>').join('')+
            '<option value="-1">'+i18n.get("recurrency.lastofmonth")+'</option>')
          recurrencyStartDay.val(budgetBean.recurrencyStartDay).trigger('change')
          break;
        }
        case 'SEMI_MONTHLY':{
          recurrencyStartDay.parent('label').show()
          recurrencyStartDay.html(
            '<option value="15">'+i18n.get("budget.label.semimonthly_first")+'</option>'+
            '<option value="30">'+i18n.get("budget.label.semimonthly_last")+'</option>'
            )
          if(recurrencyChanged){
            recurrencyStartDay.val(15).trigger('change')
          }else{
            recurrencyStartDay.val(budgetBean.recurrencyStartDay).trigger('change')
          }
          break;
        }
        case 'BIWEEKLY':{
          recurrencyStartDay.parent('label').show();
          var 
            days = [],
            rangeWithoutStart = DateUtils.getWeekRange(new Date(),budgetBean.recurrencyStartDay,2);
          for(var i=0;i<14;i++){
            var 
              newRecurrencyStartDay = i+budgetBean.recurrencyStartDay,
              date = new Date(rangeWithoutStart.start);
            date.setDate(date.getDate()+i);
            if(newRecurrencyStartDay>14){
              newRecurrencyStartDay -= 14;
            }
            if(date>new Date()){
              date.setDate(date.getDate()-14);
            }
            let name;
            if(DateUtils.isSameDay(date,new Date())){
              name = i18n.get('deltatime.today')
            }else if(DateUtils.isSameDay(date,new Date(new Date().getTime()-3600000*24))){
              name = i18n.get('deltatime.yesterday')
            }else{
              name = new Intl.DateTimeFormat(i18n.getSelectedLanguage(),{month: "short", weekday:"long",day: "numeric"}).format(date)
            }
            days.push({
              recurrencyStartDay:newRecurrencyStartDay,
              date:date,
              name:name+" ("+i18n.get('timetable.week')+' '+DateUtils.getWeekNumber(date)+')'
            })
          }
          days.sort((b,a)=>{
            return a.date-b.date;
          });
          
          recurrencyStartDay.html(
            days.map(dayInfo=>'<option value="'+dayInfo.recurrencyStartDay+'">'+dayInfo.name+'</option>').join('')
          )
          if(recurrencyChanged){
            recurrencyStartDay.val(days[0].recurrencyStartDay).trigger('change')
          }else{
            recurrencyStartDay.val(budgetBean.recurrencyStartDay).trigger('change')
          }
          break;
        }
        case 'WEEKLY':{
          recurrencyStartDay.parent('label').show()
          recurrencyStartDay.html(
            DateUtils.getWeekDays().map(day=>'<option value="'+day.index+'">'+day.name+'</option>').join('')
          )
          recurrencyStartDay.val(budgetBean.recurrencyStartDay).trigger('change')
          break;
        }
        default:{
          recurrencyStartDay.parent('label').hide();
          recurrencyStartDay.html('');
        }
        
      }
    
  }
  name.on('input',function(){
    submit.toggleClass("secondary",$(this).val().trim().length===0)
  })
  name.on('change',function(){
    budgetBean.name = $(this).val();
  })
  paidUsage.on('change',function(){
    budgetBean.paidUsage = $(this).val();
    if(budgetBean.paidUsage === 'PAID'){
      const 
        rangeUntilToday = DateUtils.getRangeUntil(DateUtils.getEndOfDay(new Date())),
        transactionsUnPaid = budgetBean.getTransactionList(rangeUntilToday).filter(transaction=>!transaction.isPaid());
      if(transactionsUnPaid.length>0){
        modal.ask({
          h2:"budget.updatepast",
          message:"budget.updatepasttext",
          lottie:'images/lottie/face_with_monocle.json',
          button:[{
            title:'budget.updatepastok',
            onclick:()=>{
              ApiServer.budgetmarkaspaid(transactionsUnPaid.map(t=>t.metaId)).then((result)=>{
                modal.toastDone('budget.pasttransactionpaid',transactionsUnPaid.length)
              })
              amplify.publish("budgetNeedRefresh")
            },
          },{
            title:'budget.updatepastcancel',
            action:"modalclose",
            class:"secondary"
          }]
        })
      }  
    }
  })
  markallaspaid.on('click',function(){
    const 
      rangeUntilToday = DateUtils.getRangeUntil(DateUtils.getEndOfDay(new Date())),
      transactionsUnPaid = budgetBean.getTransactionList(rangeUntilToday).filter(transaction=>!transaction.isPaid());
      
    modal.ask({
      h2:"budget.updatepast",
      message:"budget.updatepasttext2",
      lottie:'images/lottie/face_with_monocle.json',
      button:[{
        title:'budget.updatepastok',
        onclick:()=>{
          if(transactionsUnPaid.length===0){
            modal.toastDone('budget.pasttransactionpaid',transactionsUnPaid.length)
            return;
          }
          ApiServer.budgetmarkaspaid(transactionsUnPaid.map(t=>t.metaId)).then((result)=>{
            modal.toastDone('budget.pasttransactionpaid',transactionsUnPaid.length)
          })
          amplify.publish("budgetNeedRefresh")
        },
      },{
        title:'budget.updatepastcancel',
        action:"modalclose",
        class:"secondary"
      }]
    })
  })
  recurrency.on('change',function(){
    budgetBean.recurrencyStartDay = 1;
    budgetBean.recurrencyDescriptor.recurrency = $(this).val();
    updateUI(true)
  })
  recurrencyStartDay.on('change',function(){
    if(recurrency.val()==='SEMI_MONTHLY'){
      var value = $(this).val()
      budgetBean.recurrencyStartDay =  value;
      budgetBean.recurrencyDescriptor.byMonthDay = value==='30'?'15':'1';
      
    }else{
      budgetBean.recurrencyStartDay = $(this).val();
      budgetBean.recurrencyDescriptor.byMonthDay = '';
    }
  })
  emoji.on('change',function(){
    budgetBean.emoji = $(this).val();
  })
  isrecurrent.on('change',function(){
    if(metaId && budgetBean.recurrencyDescriptor.recurrency!=='NONE'){
      modal.ask({title:"budget.switchtype.title",message:"budget.switchtype.message",button:[
        {title:"budget.actions.switch",value:true},
        {title:"actions.cancel",class:"secondary"}
      ],lottie:"images/lottie/face_with_monocle.json"},function(resp){
        if(resp===null){
          budgetBean.recurrencyDescriptor.recurrency='NONE'
        }
        updateUI(true);
        
      })  
    }else{
      budgetBean.recurrencyDescriptor.recurrency = {"true":'MONTHLY',"false":'NONE'}[$(this).val()]
      updateUI(true);
    }
  })
  currencyCode.on('change',function(){
    budgetBean.currencyCode = $(this).val()
  })
  budgetCategoryLimits.on('wanachange',function(event){
    openCategoryLimitModal(budgetBean) 
  })
  budgetLimit.on('focus wanachange',function(event,wanachangeInfo){
    event.preventDefault();
    openLimitModal(budgetBean,wanachangeInfo)
  })

  setTimeout(function(){
    updateUI();
    name.select();
  },0)
  
  form.on('submit',function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if(!forms.validate(form)){
      return false;
    }
    var sharedToAllInput = form.get(0).sharedToAll;
    if(sharedToAllInput){
      budgetBean.sharedToAll = sharedToAllInput.value === 'true';
  	  var checkedUsers = form.get(0).sharedMemberIds.querySelectorAll("option:checked");
      budgetBean.sharedMemberIds = Array.from(checkedUsers).map(el => el.value);
    }
    if(!budgetBean.isCategoryLimitValid()){
      budgetBean.budgetLimitCategoryActive = false;
    }
    ApiServer.budgetput(budgetBean,function(){
      modal.closeModal();
      if(!metaId){
        Confetti.start(2000);
        modal.simple({title:"budget.createdtitle",message:"budget.created",button:"budget.gotomybudget",lottie:"/images/lottie/53775.json"})
      }else{
        modal.snackDone('budget.budgetsaved')
      }
    },function(err){
      if(err.code==="63"){
        modal.oops("budget.errors.63",function(){
          name.selectAll()
        })
      }else{
        throw err;
      }
    })
  })
}
Html.registerWidget('widget/form/budgetForm',{init:init,destroy:destroy})
